import {
  Component,
  computed,
  effect,
  ElementRef,
  input,
  model,
  output,
  ViewChild,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'boels-quantity',
  imports: [TranslocoModule, FormsModule],
  templateUrl: './quantity.component.html',
  styleUrl: './quantity.component.scss',
})
export class QuantityComponent {
  value = model.required<number>();
  disabled = input<boolean>(false);
  hasAutoFocus = input<boolean>(false);
  editSettings = input<{
    min?: number;
    max?: number;
    step?: number;
  }>({});
  editValues = computed(() => {
    const { min = 0, max = 9999, step = 1 } = this.editSettings();
    return { min, max, step };
  });

  autoFocusEffect = effect(() => {
    if (this.quantityInput && this.quantityInput.nativeElement) {
      if (this.hasAutoFocus()) this.quantityInput.nativeElement.focus();
    }
  });

  quantityChanged = output<number>();

  @ViewChild('quantityInput') quantityInput: ElementRef;

  increment() {
    this.value.set(this.value() + this.editValues().step);
    this.quantityChanged.emit(this.value());
  }

  decrement() {
    this.value.set(this.value() - this.editValues().step);
    this.quantityChanged.emit(this.value());
  }

  validateInput(input: HTMLInputElement) {
    if (this.value() < this.editValues().min) {
      this.value.set(this.editValues().min);
      this.quantityChanged.emit(this.value());
      input.value = this.value().toString();
    }
  }

  edit() {
    this.quantityChanged.emit(this.value());
  }
}
